import React, { useContext, useEffect, useState } from "react";
import * as GrIcons from "react-icons/gr";
import LoadingSpinner from "../utilities/LoadingSpinner";
import moment from "moment";

import AdminRestrationContext from "../../context/adminRegistration/adminRegistrationContext";

const SiteItem = ({ item, selectedStudent, setStudent }) => {
  const {
    match_type,
    sis_charter,
    sis_student_first_name,
    sis_student_last_name,
    sis_student_dob,
    sis_local_id,
    sis_district_id,
    start_date,
    finish_date,
    sis_school_email,
    url,
  } = item;
  return (
    <tr>
      <td>{match_type}</td>
      <td>{sis_charter}</td>
      <td>{`${sis_student_first_name} ${sis_student_last_name}`}</td>
      <td>{moment.utc(sis_student_dob).format("MM/DD/yyyy")}</td>
      <td>{sis_local_id}</td>
      <td>{sis_district_id}</td>
      <td>{moment.utc(start_date).format("MM/DD/yyyy")}</td>
      <td>
        {finish_date === null
          ? ""
          : moment.utc(finish_date).format("MM/DD/yyyy")}
      </td>
      <td>{sis_school_email}</td>
      <td>
        <a target="_blank" href={url} className="btn btn-llac-light-green">
          Link
        </a>
      </td>
      {Object.keys(selectedStudent).length === 0 ? (
        <td>
          <div
            onClick={() => {
              setStudent(item);
            }}
            className="btn btn-llac-light-grey"
          >
            Select
          </div>
        </td>
      ) : (
        <td>
          <div
            onClick={() => {
              setStudent({});
            }}
            className="btn btn-llac-light-grey"
          >
            Deselect
          </div>
        </td>
      )}
    </tr>
  );
};

const StudentMatchModal = ({ type, id }) => {
  const adminRegistrationContext = useContext(AdminRestrationContext);
  const {
    setFormModal,
    studentMatchLoading,
    studentMatchResults,
    registrationStatusUpdate,
  } = adminRegistrationContext;
  const [selectedStudent, setSelectedStudent] = useState({});
  const [newStatus, setNewStatus] = useState("");

  useEffect(() => {}, []);

  const updateStatusForm = (
    <div className="form status-update-form">
      {/* <h4>Select Student Action</h4> */}
      <select value={newStatus} onChange={(e) => setNewStatus(e.target.value)}>
        <option value="">Please select student action</option>
        <option value="Interdistrict Transfer Requested">
          Request Interdistrict Transfer
        </option>
        <option value="Auto Withdraw Requested">Request Auto Withdraw</option>
      </select>
    </div>
  );

  const handleSubmit = () => {
    if (newStatus !== "") {
      registrationStatusUpdate(
        {
          status: newStatus,
          progressLevel: 0,
          processingLevel: 0,
        },
        type,
        id
      );
      setFormModal("studentMatchModal", false);
    }
  };

  return (
    <div id="student-match-modal" className="modal">
      <div className="student-match-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("studentMatchModal", false)}
          />
          <h2>Find Student Match</h2>
        </div>
        <div className="modal-body">
          <div className="search-results">
            {studentMatchLoading ? (
              <LoadingSpinner />
            ) : typeof studentMatchResults !== "undefined" &&
              studentMatchResults.length > 0 ? (
              <table>
                <tr>
                  <th>Match Type</th>
                  <th>Charter</th>
                  <th>Name</th>
                  <th>Birth Date</th>
                  <th>Local ID</th>
                  <th>District ID</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>School Email</th>
                  <th>SIS Link</th>
                  {/* {Object.keys(selectedStudent).length === 0 && <th>Action</th>} */}
                  <th>Action</th>
                </tr>
                {Object.keys(selectedStudent).length !== 0 ? (
                  <SiteItem
                    item={selectedStudent}
                    setStudent={setSelectedStudent}
                    selectedStudent={selectedStudent}
                  />
                ) : (
                  studentMatchResults
                    .sort((a, b) => {
                      const date1 = new Date(a.start_date);
                      const date2 = new Date(b.start_date);
                      return date2 - date1;
                    })
                    .map((item, index) => {
                      return (
                        <SiteItem
                          key={index}
                          item={item}
                          selectedStudent={selectedStudent}
                          setStudent={setSelectedStudent}
                        />
                      );
                    })
                )}
              </table>
            ) : (
              <h2 className="text-center">No records were found to match </h2>
            )}
            {Object.keys(selectedStudent).length !== 0 && updateStatusForm}
          </div>
        </div>
        <div className="bottom-bar">
          <div className="btns">
            {Object.keys(selectedStudent).length !== 0 && (
              <div
                className={`btn btn-llac-${
                  newStatus === "" ? "light-grey" : "dark-green"
                }`}
                onClick={handleSubmit}
              >
                Confirm Action
              </div>
            )}

            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("studentMatchModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentMatchModal;
